import type { FormControl } from '@angular/forms';

export function normalizeFormControls(controls: FormControl | FormControl[]): void {
  if (Array.isArray(controls)) {
    controls.forEach(control => control.setValue(control.value?.trim()));
    return;
  }
  controls.setValue(controls.value?.trim());
}
